<template>
    <div class = "print" v-if="getPermission.scalecontrol.edit">

        <md-tabs md-sync-route class="version-tabs">
          <md-tab id="tab-scalecontrol_out" md-label="Outbound" to="/scalecontrol/out"></md-tab>
          <md-tab id="tab-scalecontrol_in" md-label="Inbound" to="/scalecontrol/in"></md-tab>
        </md-tabs>
        <router-view/>

    </div>

</template>

<style lang="scss">

  .Version-tabs {
    .md-tabs-navigation {
      .md-theme-default {
        height: 30px;
      }
    }
  }

  


</style>


<script>
  import { mapGetters } from 'vuex';

  export default {
    data: () => ({}),
    computed: {
      ...mapGetters([
        'getPermission',
        // 'getMasterDataName',
      ]),
    },
  };

</script>



